var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSb = function SvgSb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    fill: "none",
    viewBox: "0 0 21 15"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fedec6fb-e169-4cdf-8e22-540cfee0bd52a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c659c2a5-9f15-4a0c-a645-9e26a29adfb7b",
    width: 21,
    height: 15,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c659c2a5-9f15-4a0c-a645-9e26a29adfb7b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#025BC2",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCD715",
    fillRule: "evenodd",
    d: "M0 15h21V0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24663A",
    fillRule: "evenodd",
    d: "M2 15h19V2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5.122 5.658 4.504 6l.118-.724-.5-.512.69-.106.31-.658.31.658.69.106-.5.512L5.74 6zm-2-2L2.504 4l.118-.724-.5-.512.69-.106.31-.658.31.658.69.106-.5.512L3.74 4zm4 0L6.504 4l.118-.724-.5-.512.69-.106.31-.658.31.658.69.106-.5.512L7.74 4zm0 4L6.504 8l.118-.724-.5-.512.69-.106.31-.658.31.658.69.106-.5.512L7.74 8zm-4 0L2.504 8l.118-.724-.5-.512.69-.106.31-.658.31.658.69.106-.5.512L3.74 8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19 .5H2A1.5 1.5 0 0 0 .5 2v11A1.5 1.5 0 0 0 2 14.5h17a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 19 .5Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fedec6fb-e169-4cdf-8e22-540cfee0bd52a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v15H0z"
  })))));
};
export default SvgSb;